import React, { useContext, useEffect, useState, createContext } from 'react';

import {
    useNavigate,
    useLocation,
    Navigate
} from 'react-router-dom';
import Container from 'react-bootstrap/Container';

import { useSelector, useDispatch } from "react-redux";
import { setAuth } from '../actions';

import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Spinner from 'react-bootstrap/Spinner';

import { fetchRequest } from '../fetchRequest';
import { toast } from 'react-toastify';
import Select from 'react-select'

const Login = ({ }) => {
    let navigate = useNavigate();
    let location = useLocation();
    const dispatch = useDispatch();

    const { currentUser } = useSelector((state) => state.auth);

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);

    const [updateView, setUpdateView] = useState(false);

    const [loginUser, setLoginUser] = useState(null);
    const [showSchoolSelection, setShowSchoolSelection] = useState(false);
    const [selectedSchool, setSelectedSchool] = useState(null);


    const submitLogin = () => {

        if (username && username.length > 0
            && password && password.length > 0) {
            let bodyParams = {
                username,
                password
            }
            setLoading(true);
            setShowSchoolSelection(false);
            fetchRequest("auth/login", 'POST', bodyParams)
                .then(res => {
                    if (res?.success) {
                        let userObj = res;
                        const schools = res?.schools;
                        if (schools) {
                            setLoginUser(userObj);
                            if (schools.length > 0) {
                                if (schools.length > 1) {
                                    setShowSchoolSelection(true);
                                    setUpdateView(!updateView);
                                } else {
                                    userObj.school = schools[0].id;
                                    userObj.schoolName = schools[0].schoolName;
                                    userObj.schoolRegister = schools[0].registerNo;
                                    userObj.schoolContact = schools[0].schoolContact || null;
                                    userObj.canCharge = schools[0]?.canCharge || false;
                                    userObj.showHistory = schools[0]?.showHistory || false;
                                    userObj.receipt = true;
                                    userObj.golomtPos = schools[0]?.golomtPos || false;
                                    userObj.hasEbarimt = schools[0]?.hasEbarimt || false;
                                    dispatch(setAuth(userObj));
                                    navigate('/home', {
                                        replace: true
                                    });
                                }
                            } else {
                                toast.warning('Хандах эрхгүй хэрэглэгч байна', {
                                    position: "top-right",
                                    autoClose: 2000,
                                    hideProgressBar: true,
                                    closeOnClick: true,
                                    pauseOnHover: true,
                                    draggable: false
                                })
                                setLoading(false);
                            }
                        } else {
                            toast.warning('Хандах эрхгүй хэрэглэгч байна', {
                                position: "top-right",
                                autoClose: 2000,
                                hideProgressBar: true,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            })
                            setLoading(false);
                        }
                    } else {
                        toast.warning(res?.message || 'Нэвтрэх нэр эсвэл нууц үг буруу байна', {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: false
                        })
                        setLoading(false);
                    }
                }).catch(e => {
                    setLoading(false);

                    toast.warning('Хүсэлт илгээхэд алдаа гарлаа', {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: false
                    })
                })
        }
    }

    return (
        <div className="auth-container"
            style={{
                backgroundImage: `url(https://lxp-cdn.eschool.mn/erp/auth.jpg)`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                backgroundPosition: 'top'
            }}>

            <Container style={{ position: 'relative' }}>

                <Card className="portlet" style={{ position: 'absolute', top: '30vh' }}>
                    <Card.Body>

                        <Form style={{ paddingLeft: 30, paddingRight: 30, paddingTop: 20 }}>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Нэвтрэх нэр</Form.Label>
                                <Form.Control type="text" value={username} onChange={(e) => {
                                    setUsername(e.target.value)
                                }} />
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="exampleForm.ControlPassword1">
                                <Form.Label>Нууц үг</Form.Label>
                                <Form.Control type="password" value={password} onChange={(e) => {
                                    setPassword(e.target.value)
                                }} />
                            </Form.Group>
                        </Form>

                        <Row>
                            <Col style={{ textAlign: 'center' }}>
                                <button
                                    className='btn-main'
                                    disabled={loading}
                                    onClick={submitLogin}>
                                    {
                                        loading
                                            ?
                                            <Spinner animation="border"
                                                variant="warning"
                                                size="sm" />
                                            :
                                            'Нэвтрэх'
                                    }
                                </button>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>

                <Modal
                    show={showSchoolSelection}
                    centered
                    backdrop="static"
                    onHide={() => {
                        setShowSchoolSelection(false);
                    }}>
                    <Modal.Body>

                        <Row>
                            {
                                loginUser && <Select
                                    onChange={(e) => {
                                        setSelectedSchool(e);
                                    }}
                                    options={loginUser?.schools.map((schoolObj) => (
                                        {
                                            value: schoolObj?.id,
                                            label: schoolObj?.name
                                        }
                                    )
                                    )}
                                />
                            }

                        </Row>
                        <Row style={{ marginTop: 30 }}>
                            <Col className="text-center" style={{ paddingLeft: 30, paddingRight: 30 }}>
                                <Button
                                    variant="secondary"
                                    onClick={() => {
                                        setSelectedSchool(null);
                                        setLoading(false);
                                        setLoginUser(null);
                                        setShowSchoolSelection(false);
                                    }}>
                                    Цуцлах
                                </Button>
                                <Button
                                    variant="primary"
                                    style={{ marginLeft: 20 }}
                                    onClick={() => {
                                        loginUser.school = selectedSchool?.value;
                                        loginUser.schoolName = selectedSchool?.label;
                                        loginUser.schoolRegister = selectedSchool?.registerNo || null;
                                        loginUser.schoolContact = selectedSchool?.schoolContact || null;
                                        loginUser.showHistory = selectedSchool?.showHistory || false;
                                        loginUser.canCharge = selectedSchool?.canCharge || false;
                                        loginUser.golomtPos = selectedSchool?.golomtPos || false;
                                        loginUser.hasEbarimt = selectedSchool?.hasEbarimt || false;
                                        loginUser.receipt = true;
                                        dispatch(setAuth(loginUser));
                                        navigate('/home', {
                                            replace: true
                                        });
                                    }}
                                >
                                    Сонгох
                                </Button>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>

            </Container>


        </div>
    );
}
export default Login;
